module.exports = __webpack_public_path__ + "img/taiste-logo.2047d88d.svg";